// src/api/uploadApi.js
import axiosInstance from './axiosConfig';

export const uploadApi = {
  // Upload a profile image
  uploadProfileImage: async (formData) => {
    return axiosInstance.post('/upload/profile-image', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
  },

  // Delete profile image
  deleteProfileImage: async () => {
    return axiosInstance.delete('/upload/profile-image');
  },

  // Upload a chat file
  uploadChatFile: async (formData) => {
    return axiosInstance.post('/upload/chat', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
  },
};